import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import contactReducer from './contact';
import portfoliosReducer from './portfolios';
import portfoliosFilterResucer from './portfoliosFilter';

export default combineReducers({
  contact: contactReducer,
  portfolios: portfoliosReducer,
  portfoliosFilter: portfoliosFilterResucer,
  form:formReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js